// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"131":"6cbed2740d57fee78991","488":"c797883008f18e3ac715","532":"8bbf4a81c065a9b9699d","592":"540a187630423cb79047","736":"0d9f98935374e3dfa23e"}[chunkId] + ".js";
};